// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"bd_br","reviews__wrapper__list":"bd_fg","reviewSlider":"bd_fh"};